/**
 * Import all your stores
 */
import { action } from 'mobx';
import { BDPortalStore } from './BDPortalStore';
import { BidAnalysisStore } from './bidAnalysisStore';
import { DrugPortfolioManagementStore } from './FactsStores/DrugPortfolioStore';
import { FactsStore } from './FactsStores/FactsStore';
import { ConstrainedForecastEditStore } from './fdpStore/constrainedForecastEditStore';
import { ConstrainedForecastViewStore } from './fdpStore/constrainedForecastViewStore';
import { ProvisionalForecastV2Store } from './fdpStore/provisionalForecastV2Store';
import { CommonStore } from './fdpStore/SalesPlanStore/CommonStore';
import { MSPlanStore } from './fdpStore/SalesPlanStore/MSPlanStore';
import { SupplierForecastStore } from './fdpStore/SupplierForecastStore';
import { UnconstrainedForecastEditStore } from './fdpStore/unconstrainedForecastEditStore';
import { UnconstrainedForecastViewStore } from './fdpStore/unconstrainedForecastViewStore';
import { FeatureFlagStore } from './FeatureFlagStore';
import { NavbarStore } from './NavbarStore';
import { NotificationStore } from './NotificationStore';
import { LandingPageStore } from './ProductWikiStores/LandingPageStore';
import { SupportTicketStore } from './SupportTicketStore/SupportTicketStore';
import { UserStore } from './UserStores/userStore';
import { OOCStore } from './fdpStore/oocStore';
import { WebSocketStore } from './WebSocketStore';
/**
 * Root Store Class composed of SubStore
 * @field experimentLayoutStore {ExperimentLayoutStore}
 */
export class RootStore {
  UserStore: UserStore;
  FactsStore: FactsStore;
  BDPortalStore: BDPortalStore;
  ProvisionalForecastV2Store: ProvisionalForecastV2Store;
  UnconstrainedForecastViewStore: UnconstrainedForecastViewStore;
  UnconstrainedForecastEditStore: UnconstrainedForecastEditStore;
  ConstrainedForecastViewStore: ConstrainedForecastViewStore;
  ConstrainedForecastEditStore: ConstrainedForecastEditStore;
  SupplierForecastStore: SupplierForecastStore;
  PlanningSharedStore: CommonStore;
  MSPlanStore: MSPlanStore;
  DrugPortfolioManagementStore: DrugPortfolioManagementStore;
  NavbarStore: NavbarStore;
  LandingPageStore: LandingPageStore;
  BidAnalysisStore: BidAnalysisStore;
  WebSocketStore: WebSocketStore;
  NotificationStore: NotificationStore;
  SupportTicketStore: SupportTicketStore;
  OOCStore: OOCStore;
  OOCStoreUpdated: OOCStore;
  FeatureFlagStore: FeatureFlagStore;

  constructor() {
    this.FactsStore = new FactsStore();
    this.BDPortalStore = new BDPortalStore();
    this.ProvisionalForecastV2Store = new ProvisionalForecastV2Store();
    this.UnconstrainedForecastViewStore = new UnconstrainedForecastViewStore();
    this.UnconstrainedForecastEditStore = new UnconstrainedForecastEditStore();
    this.ConstrainedForecastViewStore = new ConstrainedForecastViewStore();
    this.ConstrainedForecastEditStore = new ConstrainedForecastEditStore();
    this.SupplierForecastStore = new SupplierForecastStore();
    this.PlanningSharedStore = new CommonStore();
    this.MSPlanStore = new MSPlanStore(this.PlanningSharedStore);
    this.UserStore = new UserStore();
    this.DrugPortfolioManagementStore = new DrugPortfolioManagementStore();
    this.NavbarStore = new NavbarStore();
    this.LandingPageStore = new LandingPageStore();
    this.BidAnalysisStore = new BidAnalysisStore();
    this.WebSocketStore = new WebSocketStore();
    this.NotificationStore = new NotificationStore();
    this.SupportTicketStore = new SupportTicketStore();
    this.OOCStore = new OOCStore();
    this.OOCStoreUpdated = new OOCStore();
    this.FeatureFlagStore = new FeatureFlagStore();
  }

  @action resetRoot = () => {
    this.FactsStore = new FactsStore();
    this.BDPortalStore = new BDPortalStore();
    this.ProvisionalForecastV2Store = new ProvisionalForecastV2Store();
    this.UnconstrainedForecastViewStore = new UnconstrainedForecastViewStore();
    this.UnconstrainedForecastEditStore = new UnconstrainedForecastEditStore();
    this.ConstrainedForecastViewStore = new ConstrainedForecastViewStore();
    this.ConstrainedForecastEditStore = new ConstrainedForecastEditStore();
    this.SupplierForecastStore = new SupplierForecastStore();
    this.PlanningSharedStore = new CommonStore();
    this.MSPlanStore = new MSPlanStore(this.PlanningSharedStore);
    this.UserStore = new UserStore();
    this.DrugPortfolioManagementStore = new DrugPortfolioManagementStore();
    this.NavbarStore = new NavbarStore();
    this.LandingPageStore = new LandingPageStore();
    this.BidAnalysisStore = new BidAnalysisStore();
    this.WebSocketStore = new WebSocketStore();
    this.NotificationStore = new NotificationStore();
    this.SupportTicketStore = new SupportTicketStore();
    this.OOCStore = new OOCStore();
    this.OOCStoreUpdated = new OOCStore();
    this.FeatureFlagStore = new FeatureFlagStore();
  };
}

export const rootStore = new RootStore();
